import React, { useContext, useEffect } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { RegistrationContext } from './RegistrationContainer';
import { SSOContext } from '../../components/SSO/SSO';

const RenderMessage = ({ singleSignOnStatus }) => {
  // if user is signed in with SSO, then
  if (singleSignOnStatus !== '') {
    return (
      <>
        <Typography variant="body2" gutterBottom sx={{ mb: 3 }}>
          Your account has been <strong>approved</strong> and you are now logged in.
        </Typography>
        {singleSignOnStatus === 'ENS_SYNC_FAILED' ? (
          <Typography variant="body2" gutterBottom sx={{ mb: 3, color: 'error.main' }}>
            However, there was an issue syncing your account with the GB ENS system. Please contact support for
            assistance.
          </Typography>
        ) : null}
      </>
    );
  }

  // if user is not signed in with SSO
  return (
    <Typography variant="body2" gutterBottom sx={{ mb: 3 }}>
      Your account has been <strong>approved</strong>, and we will shortly send an account activation email to set your
      password.
    </Typography>
  );
};

const ActivateAccount = () => {
  const { singleSignOnStatus } = useContext(RegistrationContext);
  const { setTriggerLogin } = useContext(SSOContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (singleSignOnStatus !== '') {
      sessionStorage.setItem('sso', '1');
      setTriggerLogin(true);
    }
  }, [singleSignOnStatus]);

  return (
    <Box>
      <Typography variant="body2" gutterBottom sx={{ mb: 3 }}>
        Thank you for completing the account application for CABIE ICS.
      </Typography>

      <RenderMessage singleSignOnStatus={singleSignOnStatus} />

      <Button
        variant="contained"
        onClick={() => {
          navigate('/');
        }}
      >
        Back to Homepage
      </Button>
    </Box>
  );
};

export default ActivateAccount;
